export default __webpack_public_path__ + "static/media/btn_big_arbitrum.ff6ad480.png";